import { render } from "./act-navigation.vue?vue&type=template&id=aa4223f0&ts=true"
import script from "./act-navigation.ts?vue&type=script&lang=ts&external"
export * from "./act-navigation.ts?vue&type=script&lang=ts&external"

import "./act-navigation.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__